import { css } from 'styled-components';
import { borderRadiusStandard, borderRadiusSmall, borderRadiusFull, borderRadiusNone } from '@nib-components/theme';
import { map } from '../../breakpoint';
const mapStringToSelector = (string)=>{
    switch(string){
        case 'none':
            return borderRadiusNone;
        case 'small':
            return borderRadiusSmall;
        case 'standard':
            return borderRadiusStandard || '4px';
        case 'full':
            return borderRadiusFull;
    }
};
export const borderRadius = ()=>css`
  ${({ borderRadius })=>map(borderRadius, (val)=>val !== undefined && css`
          border-radius: ${mapStringToSelector(val)};
        `)};
`;

//# sourceMappingURL=border-radius.js.map